import { registerClientMethods } from "@utils/appMethods/core";
import { $emit } from "@utils/events";

/**
 * 打开裁剪
 * @type {*|(function({}=, *): void)}
 */
export const callClientOpenPhotoAlbumWithCropper = registerClientMethods({
    callClientName: 'openPhotoAlbumWithCropper',
    callBackName: 'setPhotoAlbumWithCropperUrl',
    eventName: 'onClientSetCropperUrl'
});


/**
 * 打开相册
 * @type {*|(function({}=, *): void)}
 */
export const callClientOpenPhotoAlbum = registerClientMethods({
    callClientName: 'openPhotoAlbum',
    callBackName: 'setPhotoAlbumUrl',
    eventName: 'onClientSetPhotoAlbumUrl'
});


/**
 * 获取定位
 * @type {*|(function({}=, *): void)}
 */
export const callClientSetArriveLocation = registerClientMethods({
    callClientName: 'getArriveLocation',
    callBackName: 'setArriveLocation',
    eventName: 'onClientSetArriveLocation'
});


/**
 * 获取客户端微信code
 * @type {*|(function({}=, *): void)}
 */
export const callClientGetWithdrawalWxCode = registerClientMethods({
    callClientName: 'getWithdrawalWxCode',
    callBackName: 'setWithdrawalWxCode',
    eventName: 'onGetClientWxCode'
});


/**
 * 扫码
 * @type {*|(function({}=, *): void)}
 */
export const callClientScanMeetCode = registerClientMethods({
    callClientName: 'scanMeetCode',
    callBackName: 'scanMeetCodeSuccess',
    eventName: 'onClientScanSuccess'
});

/**
 * 获取下单用户位置
 * @type {*|(function({}=, *): void)}
 */
export const callClientGetAssistantOrderLocation = registerClientMethods({
    callClientName: 'getAssistantOrderLocation',
    callBackName: 'setAssistantOrderLocation',
    eventName: 'onClientGetOrderLocation'
});


/**
 * 助理订单详情导航
 * @type {*|(function({}=, *): void)}
 */
export const callClientNavigationToServiceLocation = registerClientMethods({
    callClientName: 'navigationToServiceLocation',
});

/**
 * 保存图片 - database64
 * @type {*|(function({}=, *): void)}
 */
export const callClientSaveImgAlbum = registerClientMethods({
    callClientName: 'saveImgAlbum',
});

/**
 * 保存图片 - 网络图片地址
 * @type {*|(function({}=, *): void)}
 */
export const callClientSaveImageToAlbum = registerClientMethods({
    callClientName: 'saveImageToAlbum',
});

/**
 * 微信分享- 分享出去小程序卡片
 * @type {*|(function({}=, *): void)}
 */
export const callClientShareWxMini = registerClientMethods({
    callClientName: 'shareWxMini',
});

/**
 * 分享朋友圈 微信好友
 * @type {*|(function({}=, *): void)}
 */
export const callClientShareWxInviteFriend = registerClientMethods({
    callClientName: 'shareWxInviteFriend',
});

/**
 * 创建订单获取微信appid
 * @type {*|(function({}=, *): void)}
 */
export const callClientGetWXAppId = registerClientMethods({
    callClientName: 'getWXAppId',
    callBackName: 'setWXAppId',
    eventName: 'onGetWXAppId'
});

/**
 * 支付宝支付成功失败回调
 */
export const _zfbPayFinish = () => {
    $emit('onClientZfbPayFinish');
}

/**
 * 支付宝支付成功回调
 */
export const _zfbPaySuccess = () => {
    $emit('onZfbPaySuccess');
}

/**
 * 微信支付成功回调
 */
export const _wxPaySuccess = () => {
    $emit('onWxPaySuccess');
}

/**
 * 获取用户userId
 * @type {*|(function({}=, *): void)}
 */
export const callClientGetUserId = registerClientMethods({
    callClientName: 'getUserId',
    callBackName: 'setUserId',
    eventName: 'onGetUserId'
});

/**
 * 给客户端传接单城市，客户端跳转实名验证
 * @type {*|(function({}=, *): void)}
 */
export const callClientJumpAuthAssistant = registerClientMethods({
    callClientName: 'jumpAuthAssistant',
});

/**
 * 抢单支付
 * @type {*|(function({}=, *): void)}
 */
export const callCreatePublishOrder = registerClientMethods({
    callClientName: 'createPublishOrder',
});

/**
 * 新增抢单订单
 * @type {(function({}=, *): void)|*}
 */
export const callAddAppointOrder = registerClientMethods({
    callClientName: 'addAppointOrder',
});

/**
 * 抢单订单状态变更
 * @type {(function({}=, *): void)|*}
 */
export const callUpdateAppointOrder = registerClientMethods({
    callClientName: 'updateAppointOrder',
});
